import axios from "axios"
import { BASE_URL } from "../../constants/urls";


/**
 * Patch api with token
 * @param {Object} data
 * @param {string} path
 * @returns {Promise}
 */
const patchApi = (data, path) => {
    return axios.patch(
        BASE_URL + path, data
    )
}


export {
    patchApi
}
